<script setup lang="ts">
defineSlots<{
  left?: () => unknown;
  center?: () => unknown;
  right?: () => unknown;
}>();
</script>

<template>
  <div class="flex flex-wrap sm:grid sm:grid-cols-[1fr_auto_1fr] gap-2 md:gap-6 items-center">
    <div class="flex justify-start">
      <slot name="left" />
    </div>
    <div class="grow flex justify-center">
      <slot name="center" />
    </div>
    <div class="flex justify-end">
      <slot name="right" />
    </div>
  </div>
</template>
